/**
    These are global constants that you can import on to partials
*/

export const CHARACTER_LIMIT_DESKTOP: number = 300;
export const CHARACTER_LIMIT_TABLET: number = 150;
export const CHARACTER_LIMIT_MOBILE: number = 100;